import {ChatStatus} from '../../copilot.enums';
import {ChatState} from '../../copilot.types';
import {PlanCollapseState} from '../../plan/plan.enums';

export default function chatState(chatId: string): ChatState {
  return {
    id: chatId,
    chatItems: [],
    modalWidget: null,
    blockingChatItemId: null,
    informationText: '',
    draftMessage: {
      text: '',
      fileIds: [],
    },
    plan: null,
    status: ChatStatus.Idle,
    isPlanModeToggleOn: false,
    planCollapseState: PlanCollapseState.Expanded,
    contextWindowUsage: 0,
  };
}
